export enum DropOffTypeEnum {
  WAIT_AND_RETURN = 'Wait and Return',
  DROP_ONLY = 'Drop Only',
}
